type TelegramWebApp = {
  initData: string;
  initDataUnsafe: {
    user?: { id: number; first_name: string; username?: string };
  };
  ready: () => void;
  expand: () => void;
  openTelegramLink?: (url: string) => void;
};

declare global {
  interface Window {
    Telegram?: { WebApp?: TelegramWebApp };
  }
}

export type TgContext = {
  webApp: TelegramWebApp;
  initData: string;
};

export function getTgContext(): TgContext | null {
  const webApp = window.Telegram?.WebApp;
  if (!webApp) return null;
  if (!webApp.initData) return null;
  return { webApp, initData: webApp.initData };
}

export function openTgLink(url: string): void {
  const webApp = window.Telegram?.WebApp;
  if (webApp?.openTelegramLink) {
    webApp.openTelegramLink(url);
    return;
  }
  window.open(url, '_blank', 'noopener,noreferrer');
}
